import { render, staticRenderFns } from "./ExtraFields.vue?vue&type=template&id=2c727e99&scoped=true&lang=pug"
import script from "./ExtraFields.vue?vue&type=script&lang=js"
export * from "./ExtraFields.vue?vue&type=script&lang=js"
import style0 from "./ExtraFields.vue?vue&type=style&index=0&id=2c727e99&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c727e99",
  null
  
)

export default component.exports